
export const workOrders = [
  {
    id: 1,
    title: 'Replace Motor Bearings',
    description: 'Motor bearings showing signs of wear, replacement needed',
    asset: 'Motor A-101',
    priority: 'high',
    status: 'pending',
    assignedTo: 'João Silva',
    createdDate: '2024-01-01',
    dueDate: '2024-01-15',
    estimatedHours: 4,
    actualHours: 0,
    category: 'mechanical'
  },
  {
    id: 2,
    title: 'Hydraulic System Leak Repair',
    description: 'Minor leak detected in hydraulic line, needs immediate attention',
    asset: 'Hydraulic Press B-205',
    priority: 'high',
    status: 'in_progress',
    assignedTo: 'Maria Santos',
    createdDate: '2024-01-02',
    dueDate: '2024-01-08',
    estimatedHours: 3,
    actualHours: 1.5,
    category: 'hydraulic'
  },
  {
    id: 3,
    title: 'Conveyor Belt Alignment',
    description: 'Conveyor belt running off track, alignment adjustment required',
    asset: 'Conveyor C-301',
    priority: 'medium',
    status: 'pending',
    assignedTo: 'Pedro Costa',
    createdDate: '2024-01-03',
    dueDate: '2024-01-20',
    estimatedHours: 2,
    actualHours: 0,
    category: 'mechanical'
  },
  {
    id: 4,
    title: 'Electrical Panel Inspection',
    description: 'Routine electrical safety inspection and testing',
    asset: 'Main Panel D-401',
    priority: 'medium',
    status: 'completed',
    assignedTo: 'Ana Oliveira',
    createdDate: '2023-12-28',
    dueDate: '2024-01-05',
    estimatedHours: 6,
    actualHours: 5.5,
    category: 'electrical'
  },
  {
    id: 5,
    title: 'Pump Seal Replacement',
    description: 'Water pump seal failure, replacement parts ordered',
    asset: 'Water Pump E-501',
    priority: 'high',
    status: 'pending',
    assignedTo: 'Carlos Ferreira',
    createdDate: '2024-01-04',
    dueDate: '2024-01-12',
    estimatedHours: 3,
    actualHours: 0,
    category: 'mechanical'
  },
  {
    id: 6,
    title: 'HVAC Filter Replacement',
    description: 'Monthly HVAC filter replacement and system check',
    asset: 'HVAC Unit F-601',
    priority: 'low',
    status: 'completed',
    assignedTo: 'João Silva',
    createdDate: '2024-01-01',
    dueDate: '2024-01-10',
    estimatedHours: 1,
    actualHours: 0.5,
    category: 'hvac'
  },
  {
    id: 7,
    title: 'Compressor Oil Change',
    description: 'Scheduled oil change for air compressor unit',
    asset: 'Air Compressor G-701',
    priority: 'medium',
    status: 'in_progress',
    assignedTo: 'Maria Santos',
    createdDate: '2024-01-05',
    dueDate: '2024-01-18',
    estimatedHours: 2,
    actualHours: 1,
    category: 'mechanical'
  },
  {
    id: 8,
    title: 'Safety Valve Testing',
    description: 'Annual safety valve testing and certification',
    asset: 'Boiler H-801',
    priority: 'high',
    status: 'pending',
    assignedTo: 'Pedro Costa',
    createdDate: '2024-01-06',
    dueDate: '2024-01-25',
    estimatedHours: 8,
    actualHours: 0,
    category: 'safety'
  }
];
